import {
    useEffect,
    useState
} from 'react'

import { useLoaderData } from '@remix-run/react'

import { useIsomorphicLayoutEffect } from '@gotamedia/fluffy'
import { ButtonVariants } from '@gotamedia/fluffy/Button'
import useWindowSize from '@gotamedia/fluffy/hooks/useWindowSize'

import { AvailableApps } from '~/config/apps'

import useViewSize from '~/hooks/useViewSize'
import useEmbeddedRect from '~/hooks/useEmbeddedRect'

import { ItemType } from '~/services/resolvers/types'

import FamilyWidgetCards from '~/components/Widgets/FamilyWidgetCards'
import JobWidgetCards from '~/components/Widgets/JobWidgetCards'
import MarketGuideWidgetCards from '~/components/Widgets/MarketGuideWidgetCards'
import ChurchEventWidgetCards from '~/components/Widgets/ChurchEventWidgetCards/ChurchEventWidgetCards'

import * as Styled from '~/components/Widgets/style'

const Widgets = () => {
    const data = useLoaderData()

    let title = 
        data.id === AvailableApps.Jobs ? 'Lediga jobb' : 
            data.id === AvailableApps.MarketGuide ? 'Hitta företag och tjänster' : 
                data.id === AvailableApps.ChurchEvent ? 'Kyrkoevenemang' : 
                    data._type === ItemType.MemorialAd ? 'Dödsannonser' : 
                        'Fira'

    const windowSize = useWindowSize()

    const [isReady, setIsReady] = useState(false)
    const { isLarge } = useViewSize()
    useIsomorphicLayoutEffect(() => {
        setIsReady(true)
    }, [])

    const {
        rectRefSetter,
        revalidate
    } = useEmbeddedRect(data?.payload?.length)

    const sliderSize = !isLarge() ? windowSize.width : windowSize.width > 1600 ? 1600 - 280 : windowSize.width - 280

    useEffect(() => {
        if (isReady) {
            revalidate({ force: true })
        }
    }, [revalidate, isReady])

    const getCards = () => {
        switch (data.id) {
            case AvailableApps.MarketGuide:
                return (
                    <MarketGuideWidgetCards width={sliderSize} />
                )

            case AvailableApps.Jobs:
                return (
                    <JobWidgetCards width={sliderSize} />
                )

            case AvailableApps.Family:
                return (
                    <FamilyWidgetCards width={sliderSize} />
                )
            
            case AvailableApps.ChurchEvent:
                return (
                    <ChurchEventWidgetCards width={sliderSize} />
                )

            default:
        }
    }

    const getSubHeadline = () => {
        switch (data.id) {
            case AvailableApps.MarketGuide:
                return "Sök bland lokala företag"

            case AvailableApps.Jobs:
                return "Hitta din nästa arbetsgivare här"

            case AvailableApps.ChurchEvent:
                return "Se vad som arrangeras i din kyrka"
    
            default:
                if (data._type === ItemType.MemorialAd) {
                    return "Döds- och minnesannonser samlade på en plats"
                }   return "Födelsedagar, giftermål och annat värt att fira"
        }
    }

    const getButtonText = () => {
        switch (data.id) {
            case AvailableApps.MarketGuide:
                return "Visa fler företag"

            case AvailableApps.Jobs:
                return "Visa fler jobb"

            case AvailableApps.ChurchEvent: 
                return "Visa fler evenemang"

            default:
                return "Visa fler annonser"
        }
    }

    const getUrl = () => {
        switch (data.id) {
            case AvailableApps.Family:
                if (data._type === ItemType.MemorialAd) {
                    return `/minnas/`
                }
                return `/fira/`

            default:
                return `/`
        }
    }

    return (
        <Styled.Container ref={rectRefSetter}>
            <Styled.Headline>
                {title}
            </Styled.Headline>

            <Styled.ContainerWrapper>
                <Styled.Wrapper>
                    {getCards()}
                </Styled.Wrapper>

                <Styled.InfoWrapper>
                    {isLarge() &&
                        <Styled.SubHeadline>
                            {getSubHeadline()}
                        </Styled.SubHeadline>
                    }

                    <Styled.Anchor
                        href={getUrl()}
                        target={'_blank'}
                    >
                        <Styled.ButtonLink variant={ButtonVariants.OutlineTransparent}>
                            {getButtonText()}
                        </Styled.ButtonLink>
                    </Styled.Anchor>
                </Styled.InfoWrapper>

            </Styled.ContainerWrapper>
        </Styled.Container>
    )
}

export default Widgets